export interface HFSelectItem {
  label: string;
  value: string | number | boolean;
  selected?: boolean;
  disabled?: boolean;
  additionalText?: string;
  subItems?: HFSelectItem[];
  imgURL?: string;
}
